import * as preact from "preact";
import PropTypes from "prop-types";
import FormField from "../FormField";
import Button from "../../Button";
import Popover from "../../Popover";
import MultiSelectableListView from "../../MultiSelectableListView";
import classname from "../../../foundation/utils/classname";
import { imageUrl } from "../../../foundation/utils/image";
import noderef from "../../../foundation/utils/noderef";
import { shallowDiffer } from "../../../foundation/utils/diff";

import "./style.css";

class MultiSelectableListViewFormField extends preact.Component {
    state = {
        isPopoverOpen: false
    }

    get selectedItemsString() {
        const { children: items, selectedItems } = this.props;

        return items
            .filter(({ props }) => selectedItems.includes(props.value))
            .map(({ props }) => props.label)
            .join(", ");
    }

    handlePopoverOpen = () => {
        if (this.props.disabled) {
            return;
        }

        this.setState({
            isPopoverOpen: true
        });
    }

    handlePopoverClose = () => {
        this.setState({
            isPopoverOpen: false
        });
    }

    handleChange = selectedItems => {
        const { name, onChange } = this.props;

        onChange(selectedItems, name);
    }

    handleSearchFilterChange = () => {
        this.componentRefs.multiSelectableListViewPopover.positionPopover();
    }

    handleKeyDown = event => {
        if (event.keyCode === Zeplin.KEY_CODE.ESC && this.state.isPopoverOpen) {
            event.preventDefault();
            this.handlePopoverClose();
        }
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown);
    }

    shouldComponentUpdate(_, state) {
        return shallowDiffer(this.state, state);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
    }

    renderPopoverContent = () => {
        const { selectedItems, children } = this.props;

        return (
            <MultiSelectableListView
                class="formFieldMultiSelectableListView"
                selectedItems={selectedItems}
                onChange={this.handleChange}
                onSearchFilterChange={this.handleSearchFilterChange}>
                {children}
            </MultiSelectableListView>
        );
    }

    render() {
        const {
            class: cssClass,
            label,
            labelWidth,
            prefix,
            placeholder,
            disabled
        } = this.props;
        const { isPopoverOpen } = this.state;
        const formFieldClassName = classname("multiSelectableListViewFormField", cssClass, { placeholder: !this.selectedItemsString });

        return (
            <FormField
                class={formFieldClassName}
                label={label}
                labelWidth={labelWidth}
                disabled={disabled}>
                <div
                    ref={noderef(this, "multiSelectableListViewContainer")}
                    class="multiSelectableListViewContainer">
                    {prefix && <p class="multiSelectableListViewPrefix">{prefix}</p>}
                    <Popover
                        ref={noderef(this, "multiSelectableListViewPopover", "componentRefs")}
                        open={isPopoverOpen}
                        onOpen={this.handlePopoverOpen}
                        onClose={this.handlePopoverClose}
                        content={this.renderPopoverContent()}
                        contentClass="multiSelectableListViewPopoverContent"
                        portalInto={this.nodeRefs.multiSelectableListViewContainer}
                        left={24}
                        centerY
                        stickToEdge
                        showAnchor>
                        <Button
                            baseRef={noderef(this, "buttonContainer")}
                            class={classname("multiSelectableListViewButton", { active: isPopoverOpen })}
                            disabled={disabled}
                            secondary>
                            <span class="ellipsis">{this.selectedItemsString || placeholder}</span>
                            <img alt="˅" src={imageUrl("img/icDropdown.svg")}/>
                        </Button>
                    </Popover>
                </div>
            </FormField>
        );
    }
}

MultiSelectableListViewFormField.propTypes = {
    name: PropTypes.string.isRequired,
    class: PropTypes.string,
    label: PropTypes.string,
    prefix: PropTypes.string,
    placeholder: PropTypes.string,
    children: PropTypes.node.isRequired,
    selectedItems: PropTypes.array,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired
};

export default MultiSelectableListViewFormField;
